import React from "react"
import { HeroSection, InsideSection } from "./components"

const HomePage: React.FC = (): JSX.Element => {
  return (
    <div className="min-h-screen bg-gray-50">
      <HeroSection />
      <InsideSection />
    </div>
  )
}

export default HomePage
